// @flow

import * as React from 'react';

import type { Actions } from '../../../types';
import Row from '../../../components/Row';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import Separator from '../../../components/Separator';
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'
import { DesktopView, MobileView } from '../../../config/mediaQuery';

type Props = {
  minHeight: string,
  displayRowMenu: Boolean,
};

const ActionsOrganizer = (props: Actions & Props) => {
  const {
    ColumnsAction,
    CopyAction,
    ExportAction,
    RefreshAction,
    MultiSortAction,
    SaveViewAction,
    clearInternalFilters,
    loading,
    displayRowMenu,
    displayMenu
  } = props;


  return (
    <>
      <DesktopView>
        <Row minHeight={props.minHeight}>
          <ActionsColumn>
            <RefreshAction />
            <ExportAction />
          </ActionsColumn>

          <ActionsColumn>
            <CopyAction />
            <ColumnsAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <SaveViewAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <ClearFiltersAction clearInternalFilters={clearInternalFilters} disabled={loading} />
          </ActionsColumn>

          <ActionsColumn>
            <MultiSortAction />
          </ActionsColumn>
        </Row>
      </DesktopView>
      <MobileView>
        <div className='action-menu-items'>
          <ActionsColumn>
            <table>
              {displayMenu &&
                <tbody>
                  <tr>
                    <td><ExportAction /></td>
                  </tr>
                  <tr>
                    <td><SaveViewAction /></td>
                  </tr>
                </tbody>
              }
              {displayRowMenu &&
                <tbody>
                  <tr>
                    <td><CopyAction /></td>
                  </tr>
                </tbody>
              }
            </table>
          </ActionsColumn>
        </div>
      </MobileView>
    </>
  );
};

export default ActionsOrganizer;
